import Emitter from 'component-emitter';
import bus from 'modules/npm-component/bus';

export default new LoggedIn();

function LoggedIn() {
  this.loggedin = false;

  bus.on('sso', data => {
    this.loggedin = !!(data && data.sso);
    this.emit('change', this.loggedin);
  });
}

Emitter(LoggedIn.prototype);

LoggedIn.prototype.onChange = function(fn) {
  if (this.loggedin) {
    fn(this.loggedin);
  }

  this.on('change', fn);
};

LoggedIn.prototype.removeChangeListener = function(fn) {
  this.off('change', fn);
};



// WEBPACK FOOTER //
// ./src/modules/loggedin/loggedin.js